import { DialogContentText } from "@material-ui/core";
import ActionDialog, { ButtonKeys } from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import React, { FC, ReactElement } from "react";

interface ConfirmDialogProps {
  buttonState: ConfirmButtonTransitionState;
  closeButtonLabel?: ButtonKeys | null;
  content: FC | ReactElement | string;
  contentAlignment?: "center" | "left" | "right";
  fullWidthButtons?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  title?: string;
}

const ConfirmDialog: FC<ConfirmDialogProps> = ({
  buttonState,
  closeButtonLabel,
  content,
  contentAlignment,
  fullWidthButtons,
  onClose,
  onConfirm,
  open,
  title
}) => (
  <ActionDialog
    closeButtonLabel={closeButtonLabel}
    confirmButtonState={buttonState}
    fullWidthButtons={fullWidthButtons}
    onClose={onClose}
    onConfirm={onConfirm}
    open={open}
    title={title || ""}
    variant="default"
  >
    <DialogContentText style={{ textAlign: contentAlignment }}>
      {content}
    </DialogContentText>
  </ActionDialog>
);

ConfirmDialog.defaultProps = {
  closeButtonLabel: null,
  contentAlignment: "left",
  fullWidthButtons: false,
  title: ""
};

export default ConfirmDialog;
